
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
import PhilosophySection from './components/PhilosophySection';
import ProductsSection from './components/ProductsSection';
import SourcingSection from './components/SourcingSection';
import NewsletterSection from './components/NewsletterSection';
import SchemaOrg from '../../components/seo/SchemaOrg';

const Home = () => {
  const organizationSchema = {
    name: '鹿年轻LunaKey',
    url: import.meta.env.VITE_SITE_URL || 'https://example.com',
    logo: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/2a94b0926f9ee3eac3e7564803200427.jfif',
    description: '鹿年轻LunaKey提供大自然最有效的超级食品，经过科学制作，融入您的日常仪式中，让您焕发光彩和永恒的活力。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English']
    }
  };

  const websiteSchema = {
    name: '鹿年轻LunaKey',
    url: import.meta.env.VITE_SITE_URL || 'https://example.com',
    description: '鹿年轻LunaKey提供大自然最有效的超级食品，经过科学制作，融入您的日常仪式中，让您焕发光彩和永恒的活力。',
    publisher: {
      '@type': 'Organization',
      name: '鹿年轻LunaKey'
    }
  };

  return (
    <div className="min-h-screen">
      <SchemaOrg type="Organization" data={organizationSchema} />
      <SchemaOrg type="WebSite" data={websiteSchema} />
      
      <Header />
      <main>
        <HeroSection />
        <StorySection />
        <PhilosophySection />
        <ProductsSection />
        <SourcingSection />
        <NewsletterSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
